export const fmt = (n, dec = 2) =>
  Number(n ?? 0).toLocaleString("pt-BR", { maximumFractionDigits: dec, minimumFractionDigits: 0 });

export const fmtInt = (n) => Number(n ?? 0).toLocaleString("pt-BR", { maximumFractionDigits: 0 });

export const fmtPct = (p) => (p == null ? "—" : `${Number(p).toLocaleString("pt-BR", { maximumFractionDigits: 1 })}%`);

export const brDate = (iso) => (iso ? iso.slice(0, 10).split("-").reverse().join("/") : "—");

export const brDateShort = (iso) => (iso ? iso.slice(5, 10).split("-").reverse().join("/") : "—");

export const periodoLabel = (f) => (f ? `${brDate(f.inicio)} – ${brDate(f.fim)}` : "");

export const CORES_STATUS = { "Em Execução": "#FFCC00", Pendente: "#78716C", Paralisada: "#DC2626", Concluída: "#059669", Cancelada: "#A1A1AA" };
